import * as z from 'zod';
import { optional, timestampSchema } from './common';

// Restaurant Category Service — the admin-curated discovery taxonomy used to
// tag restaurants/branches for storefront filters.

export const restaurantCategorySchema = z.object({
  id: z.string(),
  name: z.string().default(''),
  icon: z.string().default(''),
  is_active: z.boolean().default(true),
  created_at: optional(timestampSchema),
  updated_at: optional(timestampSchema),
});
export type RestaurantCategory = z.infer<typeof restaurantCategorySchema>;
